import React from 'react';

const Footer = () => {
  return (
    <>
      <footer className='mb-0' style={{ borderTop: '1px solid #ddd', background: '#fff' }}>
        <div className='d-flex pb-5 container pt-4'>
          <a href='/' className='navbar-brand fw-bold fs-4'>
            <span style={{ fontWeight: 500 }}>QUINSHOP</span>
          </a>
          <div className='text-center justify-content-center mx-auto mt-1'>
            <p className='mb-3 mb-md-0'>Made with LOVE &#9829; </p>
          </div>
          <div className='mt-1'>
            <p className='mb-3 mb-md-0 opacity-50'>All rights reserved.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
